import { NavLink } from 'react-router-dom';
import { Icon, type IconName, type IconTone } from './Icon';
import './ui.css';

export interface TabNavItem {
  to: string;
  label: string;
  icon?: IconName;
  tone?: IconTone;
  /** `end` keeps the index tab from matching its own children. */
  end?: boolean;
  count?: number;
}

interface TabNavProps {
  /** Names the tab set, e.g. "Member sub-modules". */
  ariaLabel: string;
  items: readonly TabNavItem[];
}

/**
 * Route-driven tabs.
 *
 * Each sub-module is its own URL rather than a piece of component state: the
 * tab is bookmarkable, the back button steps through the tabs an operator
 * actually visited, and the parent route keeps its already-loaded record while
 * only the panel below swaps — so switching tabs never re-fetches the record or
 * blanks the screen.
 */
export function TabNav({ ariaLabel, items }: TabNavProps) {
  return (
    <nav className="ui-tabs" aria-label={ariaLabel}>
      <ul className="ui-tabs__list">
        {items.map(item => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? 'ui-tabs__link ui-tabs__link--active' : 'ui-tabs__link'
              }>
              {item.icon ? <Icon name={item.icon} size="sm" tone={item.tone} /> : null}
              {item.label}
              {item.count == null ? null : (
                <span className="ui-tabs__count">{item.count}</span>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
